import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { CheckBox, FormCustom, Input, Select } from '../../Components/Form/Form';
import ReactPlaceholder from 'react-placeholder'
import SweetAlert from '../../Components/SweetAlert/SweetAlert';
import Loading from '../../Components/Layout/Styled/Loading';
import Button from 'react-bootstrap/esm/Button';
import Modal from 'react-bootstrap/esm/Modal';
import FacturaLibreSale from './FacturaLibreSale';

const FacturaLibre = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])

    const [showAlert, setShowAlert] = useState(false);
    const [timbrarModal, setTimbrarModal] = useState({
        p_name: '',
        p_id_customers: '',
        p_id_customers_verified: 0,
        p_rfc_customers: '',
        p_zip_code_customers: '',
        p_id_regimen: '',
        p_id_cfdi: '',
        p_curp_customers: '',
        p_facturama_error: '',
        p_subtotal: 0,
        p_type: ''
    })

    const [dataFilter, setDataFilter] = useState({
        p_date_start: Helpers.date.get({ format: '%Y-%m-%d', addDays: -7 }),
        p_date_end: Helpers.date.get({ format: '%Y-%m-%d' })
    })

    const [load, setLoad] = useState(false)

    const [isr, setIsr] = useState(0)
    const [total, setTotal] = useState(0)
    const [limits, setLimits] = useState([])

    const [regimen, setRegimen] = useState([]);
    const [cfdi, setCfdi] = useState([]);

    const [formatPayFac] = useState([
        { id: 'PUE', name: 'PUE' },
        { id: 'PPD', name: 'PPD' },
    ])

    useEffect(() => {
        Controllers.regimen.get_regimen().then(res => {
            setRegimen(res.data)
        })
        Controllers.cfdi.get_cfdi().then(res => {
            setCfdi(res.data)
        })

        Controllers.limit.get_limit().then(res => {
            setLimits(res.data)
        })
    }, [])

    const handleSubmit = _ => {
        setIsProccesing(true)
        Controllers.facturama.get_factura_libre(dataFilter).then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    useEffect(() => {
        handleSubmit()
    }, [])

    const [modalShow, setModalShow] = useState(false);
    const [loadSubmit, setLoadSubmit] = useState(false)

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.facturama.factura_libre_sale(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                handleSubmit()
            })
    }

    const confirmTimbrar = () => {
        if (!timbrarModal.p_id_customers_verified) {
            Helpers.toast.construct({
                response: 'warning',
                message: 'El ID Cliente no fue verificado',
                toast,
            })
            return
        }

        if (!timbrarModal.p_rfc_customers || !timbrarModal.p_curp_customers || !timbrarModal.p_zip_code_customers || !timbrarModal.p_id_regimen || !timbrarModal.p_id_cfdi) {
            Helpers.toast.construct({
                response: 'warning',
                message: 'Faltan campos por llenar',
                toast,
            })
            return
        }

        if (!isNaN(parseInt(timbrarModal.p_subtotal)) && parseInt(timbrarModal.p_subtotal) <= 0) {
            Helpers.toast.construct({
                response: 'warning',
                message: 'El subtotal debe ser mayor a 0',
                toast,
            })
            return
        }

        setLoad(true)
        Controllers.facturama.process_factura_libre({
            p_id_customers: timbrarModal.p_id_customers,
            p_name: timbrarModal.p_name,
            p_rfc_customers: timbrarModal.p_rfc_customers,
            p_zip_code_customers: timbrarModal.p_zip_code_customers,
            p_id_regimen: timbrarModal.p_id_regimen,
            p_id_cfdi: timbrarModal.p_id_cfdi,
            p_curp_customers: timbrarModal.p_curp_customers,
            p_subtotal: timbrarModal.p_subtotal,
            p_total: total.toFixed(2),
            p_isr: isr.toFixed(2),
            p_type: timbrarModal.p_type,
        }).then(res => {
            Helpers.toast.construct({
                ...res,
                toast,
            })

            if (res.response === 'success') {
                setLoad(false)
                setShowAlert(false)
                handleSubmit();
            } else {
                setLoad(false)
                handleSubmit();
            }
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setLoad(false)
            handleSubmit();
        })
    }

    useEffect(() => {
        let isr = 0;
        let total = 0;
        const subtotal = isNaN(parseFloat(timbrarModal.p_subtotal)) ? 0 : parseFloat(timbrarModal.p_subtotal)
        let findLimit = limits.find(l => subtotal >= l.min_limit && subtotal <= l.max_limit)

        if (findLimit) {
            isr = parseFloat((subtotal - parseFloat(findLimit.min_limit)) * parseFloat(findLimit.percentage_limit) + parseFloat(findLimit.quota_limit))
            total = subtotal - isr
        } else {
            total = isNaN(parseFloat(timbrarModal.p_subtotal)) ? 0 : parseFloat(timbrarModal.p_subtotal)
        }

        setIsr(isr)
        setTotal(total)
    }, [timbrarModal.p_subtotal, limits])

    const [timbrarIDSale, setTimbrarIDSale] = useState({
        p_id_factura_libre: '',
        p_rfc_customers: '',
        p_zip_code_customers: '',
        p_id_regimen: '',
        p_id_cfdi: '',
        p_invoice_change: 0,
        p_invoice_change_data: {},
        p_full_name: '',
        p_type_sale: '',
        p_payment_form_facturama: '',
    })
    const [modalShowTimbrarSale, setModalShowTimbrarSale] = useState(false);
    const [timbrarModalSale, setTimbrarModalSale] = useState({
        loadSubmit: false,
        hide: _ => setModalShowTimbrarSale(false),
    })
    const confirmTimbrarSale = _ => {
        if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
            if (!timbrarIDSale.p_invoice_change_data?.rfc_customers || !timbrarIDSale.p_invoice_change_data?.zip_code_invoice || !timbrarIDSale.p_invoice_change_data?.full_name_invoice || !timbrarIDSale.p_invoice_change_data?.id_regimen || !timbrarIDSale.p_invoice_change_data?.id_cfdi || !timbrarIDSale.p_invoice_change_data?.payment_form_facturama) {
                Helpers.toast.construct({ response: 'warning', message: 'Ingrese la información RFC, Código postal, Régimen Fiscal y Uso de CFDI', toast })
                return
            }
        } else {
            if (!timbrarIDSale.p_rfc_customers || !timbrarIDSale.p_zip_code_customers || !timbrarIDSale.p_id_regimen || !timbrarIDSale.p_id_cfdi || !timbrarIDSale.p_payment_form_facturama) {
                Helpers.toast.construct({ response: 'warning', message: 'Ingrese la información RFC, Código postal, Régimen Fiscal y Uso de CFDI', toast })
                return
            }
        }

        setTimbrarModalSale({
            ...timbrarModalSale,
            loadSubmit: true
        })

        let dataFacturama = {}
        if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
            dataFacturama = {
                p_id_factura_libre: timbrarIDSale.p_id_factura_libre,
                p_rfc_customers: timbrarIDSale.p_invoice_change_data.rfc_customers,
                p_zip_code_customers: timbrarIDSale.p_invoice_change_data.zip_code_invoice,
                p_id_regimen: timbrarIDSale.p_invoice_change_data.id_regimen,
                p_id_cfdi: timbrarIDSale.p_invoice_change_data.id_cfdi,
                p_full_name: timbrarIDSale.p_invoice_change_data.full_name_invoice,
                p_invoice_change: timbrarIDSale.p_invoice_change,
                p_payment_form_facturama: timbrarIDSale.p_invoice_change_data.payment_form_facturama,
            }
        } else {
            dataFacturama = {
                p_id_factura_libre: timbrarIDSale.p_id_factura_libre,
                p_rfc_customers: timbrarIDSale.p_rfc_customers,
                p_zip_code_customers: timbrarIDSale.p_zip_code_customers,
                p_id_regimen: timbrarIDSale.p_id_regimen,
                p_id_cfdi: timbrarIDSale.p_id_cfdi,
                p_invoice_change: timbrarIDSale.p_invoice_change,
                p_payment_form_facturama: timbrarIDSale.p_payment_form_facturama,
            }
        }

        Controllers.facturama.factura_libre_sale_timbrar(dataFacturama).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShowTimbrarSale(false)
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setTimbrarModalSale({
                    ...timbrarModalSale,
                    loadSubmit: false
                })
                handleSubmit()
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_factura_libre', text: 'ID Documento', align: 'center' },
                { name: 'created_at', text: 'Fecha', align: 'center' },
                { name: 'type', text: 'Tipo', align: 'center' },
                { name: 'id_customers', text: 'ID Cliente', align: 'center' },
                { name: 'full_name', text: 'Nombres' },
                { name: 'subtotal', text: 'Subtotal', align: 'center', render: r => '$ ' + r.subtotal },
                { name: 'isr', text: 'ISR', align: 'center', render: r => r.isr ? '$ ' + r.isr : '' },
                { name: 'total', text: 'Total', align: 'center', render: r => '$ ' + r.total },
                {
                    name: 'facturama_id', text: 'Timbrado', align: 'center', render: r => {
                        return <div className='d-flex justify-content-center align-items-center'>
                            {r.facturama_id && <div className='d-flex'>
                                <div className='badge badge-success align-self-center mr-2'>Timbrado</div>
                                <div className="align-self-center">
                                    <a href={Helpers.config.apiUrl({
                                        url: '/facturama/libre/pdf/' + r.facturama_id
                                    })} target='_blank' rel='noreferrer'>
                                        <Button variant="danger" size='xs' className='align-self-center'>
                                            <i className='fa fa-file-pdf'></i>
                                        </Button>
                                    </a>
                                </div>
                            </div>}

                            {!r.facturama_id && <Button variant="dark" size="sm" className='ml-2 d-flex' alt="Timbrar" style={{
                                fontSize: 10
                            }} onClick={e => {
                                let $this = e.currentTarget

                                let buttonHTML = $this.innerHTML;
                                $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'

                                Controllers.customers.get_customers_id({ p_id_customers: r.id_customers }).then(res => {
                                    setModalShowTimbrarSale(true)
                                    setTimbrarIDSale({
                                        p_invoice_change: r.invoice_change,
                                        p_invoice_change_data: {
                                            full_name_invoice: r.full_name ? r.full_name : '',
                                            zip_code_invoice: r.zip_code_customers ? r.zip_code_customers : '',
                                            id_regimen: r.id_regimen ? r.id_regimen : '',
                                            id_cfdi: r.id_cfdi ? r.id_cfdi : '',
                                            rfc_customers: r.rfc_customers ? r.rfc_customers : '',
                                            payment_form_facturama: r.payment_form_facturama ? r.payment_form_facturama : ''
                                        },
                                        p_full_name: res.data.full_name_customers,
                                        p_id_factura_libre: r.id_factura_libre,
                                        p_rfc_customers: res.data.rfc_customers,
                                        p_id_regimen: res.data.id_regimen,
                                        p_zip_code_customers: res.data.zip_code_customers,
                                        p_id_cfdi: res.data.id_cfdi,
                                        p_type_sale: r.type,
                                        p_payment_form_facturama: r.payment_form_facturama ? r.payment_form_facturama : ''
                                    })
                                }).catch(req => {
                                    Helpers.promise.catch({ req, toast })
                                    handleSubmit()
                                })
                                    .finally(() => $this.innerHTML = buttonHTML)
                            }}>
                                <i className='fas fa-file-invoice mr-2 align-self-center'></i>
                                <span className='align-self-center'>Timbrar</span>
                            </Button>}
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    const cboRegimen = useMemo(() => {
        if (!timbrarModal.p_id_regimen) {
            return ''
        }

        let finded = regimen.find(t => parseInt(timbrarModal.p_id_regimen) === parseInt(t.id_regimen))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_regimen} - ${finded.name_regimen}`,
            value: finded.id_regimen
        }
    }, [timbrarModal.p_id_regimen, regimen])

    const cboCfdi = useMemo(() => {
        if (!timbrarModal.p_id_cfdi) {
            return ''
        }

        let finded = cfdi.find(t => (timbrarModal.p_id_cfdi) === (t.id_cfdi))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
            value: finded.id_cfdi
        }
    }, [timbrarModal.p_id_cfdi, cfdi])
    
    const cboRegimenSale = useMemo(() => {
        if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
            if (!timbrarIDSale.p_invoice_change_data?.id_regimen) {
                return ''
            }

            let finded = regimen.find(t => parseInt(timbrarIDSale.p_invoice_change_data?.id_regimen) === parseInt(t.id_regimen))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.id_regimen} - ${finded.name_regimen}`,
                value: finded.id_regimen
            }
        } else {
            if (!timbrarIDSale.p_id_regimen) {
                return ''
            }

            let finded = regimen.find(t => parseInt(timbrarIDSale.p_id_regimen) === parseInt(t.id_regimen))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.id_regimen} - ${finded.name_regimen}`,
                value: finded.id_regimen
            }
        }
    }, [timbrarIDSale.p_id_regimen, regimen, timbrarIDSale.p_invoice_change_data, timbrarIDSale.p_invoice_change])

    const cboCfdiSale = useMemo(() => {
        if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
            if (!timbrarIDSale.p_invoice_change_data?.id_cfdi) {
                return ''
            }

            let finded = cfdi.find(t => (timbrarIDSale.p_invoice_change_data?.id_cfdi) === (t.id_cfdi))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
                value: finded.id_cfdi
            }
        } else {
            if (!timbrarIDSale.p_id_cfdi) {
                return ''
            }

            let finded = cfdi.find(t => (timbrarIDSale.p_id_cfdi) === (t.id_cfdi))

            if (!finded) {
                return ''
            }
            return {
                label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
                value: finded.id_cfdi
            }
        }
    }, [timbrarIDSale.p_id_cfdi, cfdi, timbrarIDSale.p_invoice_change_data, timbrarIDSale.p_invoice_change])

    const cboPaymentFacturama = useMemo(() => {
        if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
            if (!timbrarIDSale.p_invoice_change_data?.payment_form_facturama) {
                return ''
            }

            let finded = formatPayFac.find(t => (timbrarIDSale.p_invoice_change_data?.payment_form_facturama) === (t.id))

            if (!finded) {
                return ''
            }
            return {
                label: finded.name,
                value: finded.id
            }
        } else {
            if (!timbrarIDSale.p_payment_form_facturama) {
                return ''
            }

            let finded = formatPayFac.find(t => (timbrarIDSale.p_payment_form_facturama) === (t.id))

            if (!finded) {
                return ''
            }
            return {
                label: finded.name,
                value: finded.id
            }
        }
    }, [timbrarIDSale.p_payment_form_facturama, formatPayFac, timbrarIDSale.p_invoice_change_data, timbrarIDSale.p_invoice_change])

    const openModalComission = (type) => {
        setShowAlert(true)
        setTimbrarModal({
            p_name: '',
            p_id_customers: '',
            p_rfc_customers: '',
            p_zip_code_customers: '',
            p_id_regimen: '',
            p_id_cfdi: '',
            p_curp_customers: '',
            p_facturama_error: '',
            p_subtotal: 0,
            p_type: type
        })
    }

    return <>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={true}>
            <Card>
                <Card.Header className="flex-column flex-md-row justify-content-between">
                    <div className='mb-2'>
                        <span>Factura Libre</span>
                    </div>
                    <div className='form-row'>
                        <Button size="sm" className='mr-2 mb-2' variant="dark" onClick={_ => {
                            setModalShow(true)
                        }}>
                            <i className="fas fa-file-invoice mr-2"></i>
                            <span>Venta</span>
                        </Button>
                        <Button size="sm" className='mr-2 mb-2' onClick={_ => {
                            openModalComission('CEDEA')
                        }}>
                            <i className="fas fa-file-invoice mr-2"></i>
                            <span>CEDEA</span>
                        </Button>
                        <Button size="sm" className='mr-2 mb-2' onClick={_ => {
                            openModalComission('BONO_SEMANAL')
                        }}>
                            <i className="fas fa-file-invoice mr-2"></i>
                            <span>Bono Semanal</span>
                        </Button>
                        <Button size="sm" className='mb-2' onClick={_ => {
                            openModalComission('COMISION')
                        }}>
                            <i className="fas fa-file-invoice mr-2"></i>
                            <span>Comisión</span>
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
                        handleSubmit()
                    }}>
                        <Input
                            classNameParent="col-6 col-md-4 mb-2"
                            icon="far fa-calendar"
                            placeholder="Fecha Inicio"
                            text="Fecha Inicio"
                            onChange={e => setDataFilter({ ...dataFilter, p_date_start: e.currentTarget.value })}
                            required
                            type="date"
                            value={dataFilter.p_date_start}
                        />
                        <Input
                            classNameParent="col-6 col-md-4 mb-2"
                            icon="far fa-calendar"
                            placeholder="Fecha Fina"
                            text="Fecha Fina"
                            onChange={e => setDataFilter({ ...dataFilter, p_date_end: e.currentTarget.value })}
                            append={[<Button type="submit">
                                <i className="fa fa-search mr-2"></i>Buscar
                            </Button>]}
                            required
                            type="date"
                            value={dataFilter.p_date_end}
                        />
                    </FormCustom>
                    {dtRows}
                </Card.Body>
            </Card>

            <SweetAlert
                icon="approve"
                iconClassName="fas fa-file-invoice text-primary"
                show={showAlert}
                showCancelButton
                title={<>
                    Timbrar {timbrarModal.p_type === 'CEDEA' ? 'CEDEA' : (
                        timbrarModal.p_type === 'COMISION' ? 'Comisión' : 'Bono Semanal'
                    )} <br />
                </>}
                confirmButtonText="¡Sí, timbrar!"
                cancelButtonText="¡No, cancelar!"
                loadSubmit={load}
                onCancel={() => setShowAlert(false)}
                onConfirm={confirmTimbrar}
                content={_ => {
                    return <>
                        {timbrarModal.p_facturama_error && <div className="col-12 mb-2">
                            <small className='text-danger'>
                                {timbrarModal.p_facturama_error}
                            </small>
                        </div>}
                        <div>
                            <small>ID Cliente Existente: <i className={timbrarModal.p_id_customers_verified ? 'fa fa-check text-success' : 'fa fa-times text-danger'}></i></small>
                        </div >
                        <Input
                            text="ID Cliente"
                            type="number"
                            min="1"
                            placeholder="ID Cliente"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_id_customers}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_id_customers: e.currentTarget.value, p_id_customers_verified: 0 })
                            }}
                            append={[
                                <Button onClick={e => {
                                    if (isNaN(parseInt(timbrarModal.p_id_customers))) {
                                        Helpers.toast.construct({
                                            response: 'warning',
                                            message: 'El ID del cliente debe ser un número.',
                                            toast
                                        })
                                        return
                                    }

                                    let $this = e.currentTarget

                                    let buttonHTML = $this.innerHTML;
                                    $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'

                                    setLoad(true)
                                    Controllers.customers.get_customers_id({ p_id_customers: timbrarModal.p_id_customers }).then(res => {
                                        if (res.response !== 'success') {
                                            Helpers.toast.construct({
                                                response: res.response,
                                                message: res.message,
                                                toast
                                            })
                                            return
                                        }

                                        if (res.data.type_fee !== 'ASIMILADOS') {
                                            Helpers.toast.construct({
                                                response: 'warning',
                                                message: 'El cliente no es un ASIMILADO.',
                                                toast
                                            })
                                            return
                                        }

                                        if (res.data.code_money !== 'MXN') {
                                            Helpers.toast.construct({
                                                response: 'warning',
                                                message: 'El cliente no tiene el tipo de moneda MXN.',
                                                toast
                                            })
                                            return
                                        }

                                        setTimbrarModal({
                                            ...timbrarModal,
                                            p_name: res.data.name_customers + ' ' + res.data.last_name_customers + ' ' + res.data.last_name_mot_customers,
                                            p_id_customers: res.data.id_customers,
                                            p_rfc_customers: res.data.rfc_nomina ? res.data.rfc_nomina : '',
                                            p_zip_code_customers: res.data.zip_code_nomina ? res.data.zip_code_nomina : '',
                                            p_id_regimen: res.data.id_regimen_nomina ? res.data.id_regimen_nomina : '',
                                            p_id_cfdi: res.data.id_cfdi_nomina ? res.data.id_cfdi_nomina : '',
                                            p_curp_customers: res.data.curp_nomina ? res.data.curp_nomina : '',
                                            p_facturama_error: '',
                                            p_subtotal: 0,
                                            p_id_customers_verified: 1
                                        })
                                        setShowAlert(true)
                                    }).catch(req => {
                                        Helpers.promise.catch({ req, toast })
                                        setTimbrarModal({
                                            ...timbrarModal,
                                            p_id_customers_verified: 0
                                        })
                                    })
                                        .finally(() => {
                                            $this.innerHTML = buttonHTML
                                            setLoad(false)
                                        })
                                }}>
                                    <i className="fas fa-search"></i>
                                </Button>
                            ]}
                        />
                        <Input
                            text="Nombres Cliente"
                            placeholder="Nombres Cliente"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            disabled
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_name}
                        />
                        <Input
                            text="RFC"
                            placeholder="RFC"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_rfc_customers}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_rfc_customers: e.currentTarget.value })
                            }}
                        />
                        <Input
                            text="CURP"
                            placeholder="CURP"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_curp_customers}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_curp_customers: e.currentTarget.value })
                            }}
                        />
                        <Input
                            text="Código Postal"
                            placeholder="Código Postal"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_zip_code_customers}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_zip_code_customers: e.currentTarget.value })
                            }}
                        />
                        <Select
                            classNameParent="col-12 mb-2"
                            icon="far fa-building"
                            text="Uso de CFDI"
                            options={cfdi.map(t => {
                                return {
                                    label: `${t.id_cfdi} - ${t.name_cfdi}`,
                                    value: t.id_cfdi
                                }
                            })}
                            value={cboCfdi}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_id_cfdi: e.value, p_id_regimen: '' })
                            }}
                        />
                        <Select
                            classNameParent="col-12 mb-2"
                            icon="far fa-building"
                            text="Régimen Fiscal"
                            options={regimen.filter(r => {
                                if (!timbrarModal.p_id_cfdi) {
                                    return false
                                }

                                const cfdiAux = cfdi.find(t => t.id_cfdi === timbrarModal.p_id_cfdi)

                                if (!cfdiAux) {
                                    return false
                                }

                                return cfdiAux.regimen_ids.includes(r.id_regimen)
                            }).map(t => {
                                return {
                                    label: `${t.id_regimen} - ${t.name_regimen}`,
                                    value: t.id_regimen
                                }
                            })}
                            value={cboRegimen}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_id_regimen: e.value })
                            }}
                        />
                        <Input
                            text="Subtotal"
                            placeholder="Subtotal"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_subtotal}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_subtotal: e.currentTarget.value })
                            }}
                            type="number"
                            step="0.01"
                            min="0.01"
                        />
                        <Input
                            text="ISR"
                            placeholder="ISR"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={parseFloat(isr).toFixed(2)}
                            disabled
                        />
                        <Input
                            text="Total a Pagar"
                            placeholder="Total a Pagar"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={parseFloat(total).toFixed(2)}
                            disabled
                        />
                    </>
                }}
            />
        </ReactPlaceholder >

        <Loading show={load}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>

        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size="xl">
            <Modal.Header closeButton>
                <Modal.Title as="div">Facturar Venta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FacturaLibreSale onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} />
            </Modal.Body>
        </Modal>

        <SweetAlert
            icon="approve"
            iconClassName="fas fa-file-invoice text-primary"
            show={modalShowTimbrarSale}
            showCancelButton
            title={<>¿Desea timbrar la {timbrarIDSale.p_type_sale === 'FACTURA_GLOBAL' ? 'Factura Global' :  'Venta'}?</>}
            subtitle={<>#{timbrarIDSale.p_id_factura_libre}</>}
            confirmButtonText="¡Sí, timbrar!"
            cancelButtonText="¡No, cancelar!"
            loadSubmit={timbrarModalSale.loadSubmit}
            onCancel={timbrarModalSale.hide}
            onConfirm={confirmTimbrarSale}
            content={_ => {
                if (timbrarIDSale.p_type_sale === 'FACTURA_GLOBAL') {
                    return <></>
                }

                return <>
                    <CheckBox
                        id="switch-my-invoice"
                        classNameParent="col-12 mt-2 align-self-center"
                        text="Factura a otro nombre"
                        checked={parseInt(timbrarIDSale.p_invoice_change) === 1}
                        onChange={e => {
                            setTimbrarIDSale({ ...timbrarIDSale, p_invoice_change: e.currentTarget.checked ? 1 : 0 })
                        }}
                    />
                    <Input
                        text="Nombre Factura"
                        placeholder="Nombre Factura"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={parseInt(timbrarIDSale.p_invoice_change) === 1 ? timbrarIDSale.p_invoice_change_data?.full_name_invoice : timbrarIDSale.p_full_name}
                        onChange={e => {
                            if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
                                setTimbrarIDSale({ ...timbrarIDSale, p_invoice_change_data: { ...timbrarIDSale.p_invoice_change_data, full_name_invoice: e.currentTarget.value } })
                            } else {
                                setTimbrarIDSale({
                                    ...timbrarIDSale,
                                    p_full_name: e.currentTarget.value
                                })
                            }
                        }}
                        disabled={parseInt(timbrarIDSale.p_invoice_change) === 0}
                    />
                    <Input
                        text="RFC"
                        placeholder="RFC"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={parseInt(timbrarIDSale.p_invoice_change) === 1 ? timbrarIDSale.p_invoice_change_data?.rfc_customers : timbrarIDSale.p_rfc_customers}
                        onChange={e => {
                            if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
                                setTimbrarIDSale({ ...timbrarIDSale, p_invoice_change_data: { ...timbrarIDSale.p_invoice_change_data, rfc_customers: e.currentTarget.value } })
                            } else {
                                setTimbrarIDSale({
                                    ...timbrarIDSale,
                                    p_rfc_customers: e.currentTarget.value
                                })
                            }
                        }}
                    />
                    <Input
                        text="Código Postal"
                        placeholder="Código Postal"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={parseInt(timbrarIDSale.p_invoice_change) === 1 ? timbrarIDSale.p_invoice_change_data?.zip_code_invoice : timbrarIDSale.p_zip_code_customers}
                        onChange={e => {
                            if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
                                setTimbrarIDSale({ ...timbrarIDSale, p_invoice_change_data: { ...timbrarIDSale.p_invoice_change_data, zip_code_invoice: e.currentTarget.value } })
                            } else {
                                setTimbrarIDSale({
                                    ...timbrarIDSale,
                                    p_zip_code_customers: e.currentTarget.value
                                })
                            }
                        }}
                    />
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="far fa-building"
                        text="Uso de CFDI"
                        options={cfdi.map(t => {
                            return {
                                label: `${t.id_cfdi} - ${t.name_cfdi}`,
                                value: t.id_cfdi
                            }
                        })}
                        value={cboCfdiSale}
                        onChange={e => {
                            if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
                                setTimbrarIDSale({ ...timbrarIDSale, p_invoice_change_data: { ...timbrarIDSale.p_invoice_change_data, id_cfdi: e.value } })
                            } else {
                                setTimbrarIDSale({
                                    ...timbrarIDSale,
                                    p_id_cfdi: e.value
                                })
                            }
                        }}
                    />
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="far fa-building"
                        text="Régimen Fiscal"
                        options={regimen.filter(r => {
                            if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
                                if (!timbrarIDSale.p_invoice_change_data?.id_cfdi) {
                                    return false
                                }
                            } else {
                                if (!timbrarIDSale.p_id_cfdi) {
                                    return false
                                }
                            }

                            if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
                                const cfdiAux = cfdi.find(t => t.id_cfdi === timbrarIDSale.p_invoice_change_data?.id_cfdi)

                                if (!cfdiAux) {
                                    return false
                                }

                                return cfdiAux.regimen_ids.includes(r.id_regimen)
                            } else {
                                const cfdiAux = cfdi.find(t => t.id_cfdi === timbrarIDSale.p_id_cfdi)

                                if (!cfdiAux) {
                                    return false
                                }

                                return cfdiAux.regimen_ids.includes(r.id_regimen)
                            }
                        }).map(t => {
                            return {
                                label: `${t.id_regimen} - ${t.name_regimen}`,
                                value: t.id_regimen
                            }
                        })}
                        value={cboRegimenSale}
                        onChange={e => {
                            if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
                                setTimbrarIDSale({ ...timbrarIDSale, p_invoice_change_data: { ...timbrarIDSale.p_invoice_change_data, id_regimen: e.value } })
                            } else {
                                setTimbrarIDSale({
                                    ...timbrarIDSale,
                                    p_id_regimen: e.value
                                })
                            }
                        }}
                    />
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="far fa-building"
                        text="Forma de Pago Facturama"
                        options={formatPayFac.map(t => {
                            return {
                                label: t.name,
                                value: t.id
                            }
                        })}
                        value={cboPaymentFacturama}
                        onChange={e => {
                            if (parseInt(timbrarIDSale.p_invoice_change) === 1) {
                                setTimbrarIDSale({ ...timbrarIDSale, p_invoice_change_data: { ...timbrarIDSale.p_invoice_change_data, payment_form_facturama: e.value } })
                            } else {
                                setTimbrarIDSale({
                                    ...timbrarIDSale,
                                    p_payment_form_facturama: e.value
                                })
                            }
                        }}
                    />
                </>
            }}
        />
    </>
}

export default FacturaLibre